import { Pipe, PipeTransform, inject } from "@angular/core";
import { LocalizationService } from "../localization";

@Pipe({
    name: "dateTimeFormat",
    pure: true
})
export class DateTimeFormatPipe implements PipeTransform {
    private localizationService = inject(LocalizationService);


    transform(
        value: any,
        includeSeconds: boolean = false,
        showTime: boolean = true
    ): string | null {
        if (value == null || value === "" || value !== value) {
            return null;
        }

        if (typeof value === "string") {
            value = new Date(value);
        }

        const localizationInfo = this.localizationService.localizationInfo;
        const format = showTime
            ? includeSeconds
                ? localizationInfo.dateTimeFormat
                : localizationInfo.dateShortTimeFormat
            : localizationInfo.dateFormat;

        return this.localizationService.formatDate(value, format);
    }
}
